import { propCategory } from '../lib/natalProps.js';

// 원국에서 나온 소품(일간 오행의 소품, 현재 막의 소품)을 분류별 공통 도형과 이름으로 그린다.
// 개별 소품 그림이 아니라 종이류·식물·병과 잔·조명·도구 다섯 가지 도형이다.
const PALETTES = [
  { main: '#8e7a56', pale: '#efe6d2' }, { main: '#5d7a63', pale: '#e5eee3' },
  { main: '#6c7a96', pale: '#e6ebf3' }, { main: '#9a6a5c', pale: '#f3e5df' },
];
const INK = '#4a4338';
const PAPER = '#fbf8ef';

const GLYPHS = {
  paper: ({ p }) => <g>
    <rect x="-36" y="28" width="72" height="10" rx="2" fill={p.pale} stroke={INK} strokeWidth="1.3" />
    <rect x="-33" y="17" width="66" height="10" rx="2" fill={PAPER} stroke={INK} strokeWidth="1.3" />
    <rect x="-30" y="-40" width="60" height="56" rx="3" fill={PAPER} stroke={INK} strokeWidth="1.3" transform="rotate(-3)" />
    <path d="M-20 -26h40M-20 -14h40M-20 -2h28M-20 10h34" stroke={p.main} strokeWidth="2" strokeLinecap="round" transform="rotate(-3)" />
  </g>,
  plant: ({ p }) => <g>
    <path d="M-24 14h48l-7 38h-34z" fill={p.main} stroke={INK} strokeWidth="1.3" />
    <path d="M-27 10h54v7h-54z" fill={p.pale} stroke={INK} strokeWidth="1.3" />
    <path d="M0 10V-18" stroke={INK} strokeWidth="2" strokeLinecap="round" />
    <ellipse cx="-14" cy="-16" rx="15" ry="7" transform="rotate(-35 -14 -16)" fill="#7fa37a" stroke={INK} strokeWidth="1.2" />
    <ellipse cx="14" cy="-24" rx="15" ry="7" transform="rotate(35 14 -24)" fill="#8ab184" stroke={INK} strokeWidth="1.2" />
    <ellipse cx="0" cy="-38" rx="13" ry="6" transform="rotate(-80 0 -38)" fill="#7fa37a" stroke={INK} strokeWidth="1.2" />
  </g>,
  vessel: ({ p }) => <g>
    <path d="M-26 -22h52v30c0 22-12 38-26 38s-26-16-26-38z" fill={p.pale} stroke={INK} strokeWidth="1.3" />
    <path d="M26 -10c14-2 18 18 2 24" fill="none" stroke={INK} strokeWidth="2.2" strokeLinecap="round" />
    <path d="M-26 -8h52" stroke={p.main} strokeWidth="3" />
    <ellipse cx="0" cy="-22" rx="26" ry="5" fill={p.main} opacity=".35" stroke={INK} strokeWidth="1.2" />
  </g>,
  lamp: ({ p }) => <g>
    <ellipse cx="0" cy="50" rx="26" ry="6" fill={p.main} stroke={INK} strokeWidth="1.3" />
    <path d="M0 48V-6" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    <path d="M-26 -4l10-36h32l10 36z" fill={p.pale} stroke={INK} strokeWidth="1.3" />
    <path d="M-12 -6h24" stroke={p.main} strokeWidth="2" />
  </g>,
  tool: ({ p }) => <g>
    <rect x="-30" y="26" width="60" height="16" rx="3" fill={p.main} stroke={INK} strokeWidth="1.3" />
    <rect x="-12" y="-14" width="24" height="42" rx="4" fill={p.pale} stroke={INK} strokeWidth="1.3" />
    <circle cx="0" cy="-26" r="14" fill={PAPER} stroke={INK} strokeWidth="1.3" />
    <path d="M-6 -26h12M0 -32v12" stroke={p.main} strokeWidth="2" strokeLinecap="round" />
  </g>,
};

// 도형마다 바닥(그림 좌표 0 기준 아래쪽 끝)이 달라서, 바닥을 같은 높이에 맞춘다.
const BOTTOM = { paper: 38, plant: 52, vessel: 40, lamp: 56, tool: 42 };
const SCALE = 0.95;
const GROUND = 168;

/** labels: 소품 이름 1~2개. 같은 입력이면 같은 그림이다. */
export default function NatalObjects({ labels = [], variant = 0 }) {
  const shown = labels.filter(Boolean).slice(0, 2);
  if (!shown.length) return null;
  const index = Number.isFinite(Number(variant)) ? Math.abs(Math.trunc(Number(variant))) : 0;
  const xs = shown.length === 1 ? [160] : [100, 222];
  return <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMax meet" className="scene-prop-art" role="img"
    aria-label={`원국의 소품: ${shown.join(', ')}`} focusable="false" fill="none" strokeLinecap="round" strokeLinejoin="round">
    {shown.map((label, i) => {
      const category = propCategory(label), Glyph = GLYPHS[category];
      const p = PALETTES[(index + i) % PALETTES.length];
      const y = GROUND - BOTTOM[category] * SCALE;
      return <g key={label}>
        <ellipse cx={xs[i]} cy={GROUND + 2} rx="56" ry="9" fill="#4d514a" opacity=".16" />
        <g transform={`translate(${xs[i]} ${y}) scale(${SCALE}) rotate(${(i ? 1 : -1) * 2})`}><Glyph p={p} /></g>
        <text x={xs[i]} y="198" textAnchor="middle" fontSize="15" fill="#3b362e" stroke="none" fontWeight="600">{label}</text>
      </g>;
    })}
  </svg>;
}
